import React from "react";
import { Link } from "react-router-dom";

export default function WelcomeJourneyCard() {
    return (
        <div className="card">
            <div className="card-body">
                <div className="d-flex align-items-start justify-content-between gap-3">
                    <div className="journey-icon journey-icon-primary flex-shrink-0">
                        <i className="fas fa-route"></i>
                    </div>
                    <Link to="/welcome" className="btn btn-primary btn-sm">
                        Open
                    </Link>
                </div>
                <h4 className="my-3">Welcome Guide</h4>
                <p className="text-muted mb-0">
                    Choose mentor or student onboarding whenever you need the setup steps, videos, or app download path.
                </p>
            </div>
        </div>
    );
}
